export type NoticeAction = 'confirm' | 'save' | 'choose';

export const noticeAction = (currentCountryCode: string, selectedCountryCode: string): NoticeAction => {
    if (!selectedCountryCode) {
        return 'choose';
    }

    return selectedCountryCode === currentCountryCode ? 'confirm' : 'save';
};

export const whenTabVisible = (callback: () => void): (() => void) => {
    const listening = new AbortController();

    const callWhenVisible = (): void => {
        if (document.visibilityState === 'visible') {
            listening.abort();
            callback();
        }
    };

    document.addEventListener('visibilitychange', callWhenVisible, {signal: listening.signal});
    callWhenVisible();

    return () => listening.abort();
};

type PickerSelect = HTMLSelectElement & {showPicker?: () => void};

export const openCountryList = (container: HTMLElement): void => {
    const select = container.querySelector<PickerSelect>('select');

    if (!select) {
        return;
    }

    if (select.nextElementSibling?.classList.contains('chosen-container')) {
        select.dispatchEvent(new CustomEvent('chosen:open'));
        return;
    }

    select.focus();
    try {
        select.showPicker?.();
    } catch {
        select.click();
    }
};
